// https://github.com/uNmAnNeR/imaskjs/tree/master/packages/react-imask

import React from 'react'
import { IMaskMixin } from 'react-imask'
import { Input } from 'reactstrap'

const MaskedInput = IMaskMixin(props => (
  <Input
    innerRef={props.inputRef}
    onChange={props.onAccept}
    className="form-control"
    radix=","
    {...props}
  />
))

export default MaskedInput
